import React from 'react';

export const MarylandInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">State of Maryland</p>
        <p className="eds-l-mar-bot-1">
            <strong>Small Business COVID-19 Emergency Relief Grant Fund</strong>{' '}
            |&nbsp;
            <a
                href="https://commerce.maryland.gov/fund/maryland-small-business-covid-19-emergency-relief-grant-fund"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            $50M Grant Fund working capital to small businesses and nonprofits.
            Up to $10,000 not to exceed 3 months of cash operating expenses with
            50 or fewer employees.
        </p>
    </div>
);
